export default __webpack_public_path__ + "static/lilnadas-cards-health-2-46cc5a48a5330d86680c65ed99efbf16.png";